import React, { useState, useEffect, ChangeEvent } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { toast } from "react-toastify";
import GetAppIcon from "@mui/icons-material/GetApp";
import CustomButton from "../../../components/customButton/customButton";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import Loader from "../../../components/loader";
import GridStyles from "../../../assets/css/grid.styles";
import CustomDialog from "../../../components/customDialog/customDialog";
import CustomDataTable from "../../../components/customDataTable/customDataTable";
import {
  clearBlobData,
  deleteOpportunity,
  exportOpportunity,
  getOpportunitiesList,
} from "../../../reducers/opportunitiesReducer";
import { CustomTableColumnsProps } from "../../../components/customDataTable/customTableColumnsProps";
import {
  DELETE_ITEM_ERROR_MESSAGE,
  DELETE_OPPORTUNITY,
} from "../../../constants/actions";
import CustomIcon from "../../../components/customIcon/customIcon";
import { PermissionsActions } from "../../../constants/permissionsActions";
import { PermissionsActionsModel } from "../../../models/models/permissionsActionsModel";
import { LookupEnum, StatusValues } from "../../../constants/enums";
import theme from "../../../themes/index.en";
import { UserPermissionsModel } from "../../../models/models/userPermissionsModel";
import CustomFilter from "../../../components/customFilter/customFilter";
import {
  getInvestorsNumberRestrictionList,
  getIslamicShariaComplianceList,
  getMainPurposeOfFundUtilization,
  getTermsOfAgreementChangesList,
} from "../../../reducers/lookupReducer";

const OpportunitiesListForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const authToken = useSelector((state: RootState) => state.auth.token);
  const opportunitiesListState = useSelector(
    (state: RootState) => state.opportunities.opportunitiesList
  );
  const opportunityDetails = useSelector(
    (state: RootState) => state.opportunities.opportunityDetails
  );
  const termsOfAgreementChangesList = useSelector(
    (state: RootState) => state.lookup.termsOfAgreementChangesList
  );
  const investorsNumberRestrictionList = useSelector(
    (state: RootState) => state.lookup.investorsNumberRestrictionList
  );
  const islamicShariaComplianceList = useSelector(
    (state: RootState) => state.lookup.islamicShariaComplianceList
  );
  const mainPurposeOfFundUtilizationList = useSelector(
    (state: RootState) => state.lookup.mainPurposeOfFundUtilizationList
  );
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [exportedOpportunityTitle, setExportedOpportunityTitle] = useState("");
  const [formFilter, setFormFilter] = useState({
    fundUtilizationMainPurposes: null,
    termsOfAgreementChanges: null,
    investorsNumberRestriction: null,
    islamicShariaCompliance: null,
    fromDateApplication: "",
    toDateApplication: "",
    // isOurEmployeesInvolved: null,
    // isDirectorsInvolved: null,
    // isOurShareholdersInvolved: null,
    isOfferIssuerProvideDocuments: null,
    // isAuditorReportsProvided: null,
    // isFinPositionStatementProvided: null,
    // isIncomeStatementProvided: null,
    // isEquityChangesStatementProvided: null,
    // isCashFlowStatementProvided: null,
    // isFinancialNotesStatementProvided: null,
  });
  useEffect(() => { 
    const savedFilters = localStorage.getItem('OpportunitiesFilters');
    if (savedFilters) {
      setFormFilter(JSON.parse(savedFilters));
    }
  }, []);

  const handleResetFilters = () => { 
    setFormFilter({
      fundUtilizationMainPurposes: null,
      termsOfAgreementChanges: null,
      investorsNumberRestriction: null,
      islamicShariaCompliance: null,
      fromDateApplication: "",
      toDateApplication: "",
      // isOurEmployeesInvolved: null,
      // isDirectorsInvolved: null,
      // isOurShareholdersInvolved: null,
      isOfferIssuerProvideDocuments: null,
      // isAuditorReportsProvided: null,
      // isFinPositionStatementProvided: null,
      // isIncomeStatementProvided: null,
      // isEquityChangesStatementProvided: null,
      // isCashFlowStatementProvided: null,
      // isFinancialNotesStatementProvided: null,
    });
   
    localStorage.removeItem('OpportunitiesFilters');
    setDataReloadFlag((prev) => !prev);
    setFilterDialogOpen(false);
  };

  const handleFilterChange = (filterName: string, value: any) => {
    setFormFilter((prev) => {
      const updatedFilters = { ...prev, [filterName]: value }; 
      localStorage.setItem('OpportunitiesFilters', JSON.stringify(updatedFilters));
  
      return updatedFilters;
    });
  };
  
  
  const [filterDialogOpen, setFilterDialogOpen] = useState(false); 
  const [selectedRowToDelete, setSelectedRowToDelete] = useState<any | null>(
    null
  );
  const [dataReloadFlag, setDataReloadFlag] = useState(false);
  const [key, setKey] = useState<number>(0);
  const [sortType, setSortType] = useState<"asc" | "desc">("asc");
  const [sortBy, setSortBy] = useState<string | null>(null);

  const userPermissions: UserPermissionsModel[] = JSON.parse(
    localStorage.getItem("userPermissions") ?? "{}"
  );

  useEffect(() => {
    dispatch(
      getMainPurposeOfFundUtilization({
        lookupId: LookupEnum.MainPurposeOfFundUtilization,
      })
    );
    dispatch(
      getTermsOfAgreementChangesList({
        lookupId: LookupEnum.TermsOfAgreementChangesList,
      })
    );
    dispatch(
      getInvestorsNumberRestrictionList({
        lookupId: LookupEnum.InvestorsNumberRestriction,
      })
    );
    dispatch(
      getIslamicShariaComplianceList({
        lookupId: LookupEnum.IslamicShariaCompliance,
      })
    );
  }, []);

  for (let i = 0; i < userPermissions.length; i++) {
    const { permission, pageUrl, actions } = userPermissions[i];
    if (permission === "All" || pageUrl === "/Opportunities") {
      actions.forEach((action) => {
        PermissionsActions[
          action.toLowerCase() as keyof PermissionsActionsModel
        ] = true;
      });
      break;
    }
  }

  const handleExport = (row: any) => {
    const editId = row ? row.id : 0;
    setExportedOpportunityTitle(row.titleEn);
    dispatch(exportOpportunity({ id: editId }));
  };

  const convertToString = (input: any) => {
    if (Array.isArray(input)) {
      return input.join(",");
    }
    return input ? input.toString() : "";
  };

  useEffect(() => {
    if (opportunityDetails.blobData) {
      const url = window.URL.createObjectURL(opportunityDetails.blobData);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${exportedOpportunityTitle}.xlsx`);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      dispatch(clearBlobData());
    }
  }, [opportunityDetails.blobData, dispatch]);

  const columns: CustomTableColumnsProps[] = [
    {
      id: "titleEn",
      label: "Title (EN)",
      width: "150",
      align: "left",
      visible: true,
    },
    {
      id: "titleAr",
      label: "Title (AR)",
      width: "150",
      align: "left",
      visible: true,
    },
    {
      id: "offerIssuer",
      label: "Related Offer Issuer",
      width: "150",
      align: "left",
      visible: true,
    },
    {
      id: "sharesPercentage",
      label: "Shares Percentage % ",
      width: "150",
      align: "left",
      visible: true,
    },
    {
      id: "subscriptionMinAmount",
      label: "Subscription Min Amount (KD)",
      width: "150",
      align: "left",
      visible: true,
      renderCell: (params) => {
        const formattedAmount = new Intl.NumberFormat("en-US").format(
          params.row.subscriptionMinAmount || 0
        );
        return <span>{formattedAmount}</span>;
      },
    },
    {
      id: "subscriptionMaxAmount",
      label: "Subscription Max Amount (KD)",
      width: "150",
      align: "left",
      visible: true,
      renderCell: (params) => {
        const formattedAmount = new Intl.NumberFormat("en-US").format(
          params.row.subscriptionMaxAmount || 0
        );
        return <span>{formattedAmount}</span>;
      },
    },
    {
      id: "targetAmount",
      label: "Target Amount (KD)",
      width: "150",
      align: "left",
      visible: true,
      renderCell: (params) => {
        const formattedAmount = new Intl.NumberFormat("en-US").format(
          params.row.targetAmount || 0
        );
        return <span>{formattedAmount}</span>;
      },
    },
    {
      id: "investedAmount",
      label: "Invested Amount (KD)",
      width: "150",
      align: "left",
      visible: true,
      renderCell: (params) => {
        const formattedAmount = new Intl.NumberFormat("en-US").format(
          params.row.investedAmount || 0
        );
        return <span>{formattedAmount}</span>;
      },
    },
    {
      id: "investorsCount",
      label: "Investors Count",
      width: "150",
      align: "left",
      visible: true,
    },
    {
      id: "status",
      label: "Status",
      width: "150",
      align: "left",
      visible: true,
      renderCell: (params) => {
        const { statusId, status } = params.row;
        const getStatusColor = (status: number) => {
          switch (status) {
            case StatusValues.Active:
              return theme.palette.success.light;
            case StatusValues.Cancelled:
              return theme.palette.warning.light;
            case StatusValues.Closed:
              return theme.palette.error.light;
            case StatusValues.Draft:
              return theme.palette.text.disabled;
            default:
              return theme.palette.background.paper;
          }
        };

        return (
          <div
            style={{
              backgroundColor: getStatusColor(statusId),
              padding: "8px 12px",
              borderRadius: theme.shape.borderRadius,
              textAlign: "center",
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            {status}
          </div>
        );
      },
    },
    {
      id: "actions",
      visible: true,
      label: "Actions",
      width: "150",
      align: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {PermissionsActions.edit && (
            <CustomIcon
              tooltipText="Edit"
              onClick={() => handleEditClick(params.row)}
              style={GridStyles.editIcon}
            >
              <EditIcon />
            </CustomIcon>
          )}
          {PermissionsActions.export && (
            <CustomIcon
              tooltipText="Export Excel"
              onClick={() => handleExport(params.row)}
              style={GridStyles.viewIcon}
            >
              <GetAppIcon />
            </CustomIcon>
          )}
          {PermissionsActions.delete && (
            <CustomIcon
              tooltipText="Delete"
              onClick={() => handleDeleteClick(params.row)}
              style={GridStyles.deleteIcon}
            >
              <DeleteIcon />
            </CustomIcon>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (!authToken) {
      navigate("/Signin");
    }
  }, [authToken]);

  useEffect(() => {
    const filterData = {
      pageSize,
      currentPage,
      sortType,
      sortBy,
      fundUtilizationMainPurposes: convertToString(
        formFilter.fundUtilizationMainPurposes
      ),
      termsOfAgreementChanges: convertToString(
        formFilter.termsOfAgreementChanges
      ),
      investorsNumberRestriction: convertToString(
        formFilter.investorsNumberRestriction
      ),
      islamicShariaCompliance: convertToString(
        formFilter.islamicShariaCompliance
      ),
      fromDateApplication: formFilter.fromDateApplication,
      toDateApplication: formFilter.toDateApplication,
      // isOurEmployeesInvolved: formFilter.isOurEmployeesInvolved,
      // isDirectorsInvolved: formFilter.isDirectorsInvolved,
      // isOurShareholdersInvolved: formFilter.isOurShareholdersInvolved,
      // isAuditorReportsProvided: formFilter.isAuditorReportsProvided,
      // isFinPositionStatementProvided: formFilter.isFinPositionStatementProvided,
      // isIncomeStatementProvided: formFilter.isIncomeStatementProvided,
      // isEquityChangesStatementProvided:
      //   formFilter.isEquityChangesStatementProvided,
      // isCashFlowStatementProvided: formFilter.isCashFlowStatementProvided,
      // isFinancialNotesStatementProvided:
      //   formFilter.isFinancialNotesStatementProvided,
      isAuditorReportsProvided: formFilter.isOfferIssuerProvideDocuments,
      isFinPositionStatementProvided: formFilter.isOfferIssuerProvideDocuments,
      isIncomeStatementProvided: formFilter.isOfferIssuerProvideDocuments,
      isEquityChangesStatementProvided:
        formFilter.isOfferIssuerProvideDocuments,
      isCashFlowStatementProvided: formFilter.isOfferIssuerProvideDocuments,
      isFinancialNotesStatementProvided:
        formFilter.isOfferIssuerProvideDocuments,
    };
    dispatch(getOpportunitiesList({ data: filterData }));
  }, [dispatch, pageSize, currentPage, dataReloadFlag, sortType, sortBy]);

  const handleEditClick = (row: any) => {
    const editId = row ? row.id : 0;
    navigate(`/Opportunity/${editId}`);
  };

  const handleAddClick = () => {
    navigate(`/Opportunity`);
  };

  const handleDeleteClick = (row: any) => {
    setSelectedRowToDelete(row);
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirm = () => {
    const { id } = selectedRowToDelete;
    dispatch(deleteOpportunity({ data: id }))
      .unwrap()
      .then(() => {
        toast.success(`${DELETE_OPPORTUNITY}`);
        setDataReloadFlag((prev) => !prev);
        setDeleteConfirmationOpen(false);
        setKey((prevKey) => prevKey + 1);
        setCurrentPage(1);
      })
      .catch((error) => {
        toast.error(`${DELETE_ITEM_ERROR_MESSAGE} ${error}`);
        setDeleteConfirmationOpen(false);
      });
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmationOpen(false);
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleSortChange = (columnId: string) => {
    setSortType(sortType === "asc" ? "desc" : "asc");
    setSortBy(columnId);
  };
  const handleFilterClick = () => {
    setFilterDialogOpen(false);
    const filterData = {
      pageSize,
      currentPage,
      sortType,
      sortBy,
      fundUtilizationMainPurposes: convertToString(
        formFilter.fundUtilizationMainPurposes
      ),
      termsOfAgreementChanges: convertToString(
        formFilter.termsOfAgreementChanges
      ),
      investorsNumberRestriction: convertToString(
        formFilter.investorsNumberRestriction
      ),
      islamicShariaCompliance: convertToString(
        formFilter.islamicShariaCompliance
      ),
      fromDateApplication: formFilter.fromDateApplication,
      toDateApplication: formFilter.toDateApplication,
      isAuditorReportsProvided: formFilter.isOfferIssuerProvideDocuments,
      isFinPositionStatementProvided: formFilter.isOfferIssuerProvideDocuments,
      isIncomeStatementProvided: formFilter.isOfferIssuerProvideDocuments,
      isEquityChangesStatementProvided:
        formFilter.isOfferIssuerProvideDocuments,
      isCashFlowStatementProvided: formFilter.isOfferIssuerProvideDocuments,
      isFinancialNotesStatementProvided:
        formFilter.isOfferIssuerProvideDocuments,
    };
    dispatch(getOpportunitiesList({ data: filterData }));
    setKey((prevKey) => prevKey + 1);
  };

  const createMockChangeEvent = (
    name: string,
    value: unknown
  ): React.ChangeEvent<{ name?: string; value: unknown }> => {
    return {
      target: {
        name,
        value,
      },
      preventDefault: () => {},
      stopPropagation: () => {},
    } as React.ChangeEvent<{ name?: string; value: unknown }>;
  };
 

  return (
    <div style={GridStyles.container}>
      <div style={GridStyles.header}>
        <div style={GridStyles.titleContainer}>
          <h1 style={GridStyles.title}>Opportunities List</h1>
        </div>
        <div style={GridStyles.addButtonContainer}>
          {PermissionsActions.add && (
            <CustomButton
              type="button"
              style={GridStyles.addButton}
              onClick={() => handleAddClick()}
            >
              <AddIcon style={GridStyles.iconStyle} /> New Opportunity
            </CustomButton>
          )}
        </div>
        <div style={GridStyles.filterButtonContainer}>
          {PermissionsActions.filter && (
            <CustomButton
              type="button"
              style={GridStyles.filterButton}
              onClick={() => setFilterDialogOpen(true)}
            >
              <FilterAltIcon style={GridStyles.iconStyle} /> Filter
            </CustomButton>
          )}
        </div>
      </div>

      {opportunitiesListState.isLoading && <Loader />}
      <CustomFilter
        open={filterDialogOpen}
        onClose={() => setFilterDialogOpen(false)}
        onFilter={handleFilterClick}
        handleReset={handleResetFilters}
        filters={{
          fundUtilizationMainPurposes: formFilter.fundUtilizationMainPurposes,
          termsOfAgreementChanges: formFilter.termsOfAgreementChanges,
          investorsNumberRestriction: formFilter.investorsNumberRestriction,
          islamicShariaCompliance: formFilter.islamicShariaCompliance,
          fromDateApplication: formFilter.fromDateApplication,
          toDateApplication: formFilter.toDateApplication,
          isOfferIssuerProvideDocuments: formFilter.isOfferIssuerProvideDocuments,
          // isOurEmployeesInvolved: formFilter.isOurEmployeesInvolved,
          // isDirectorsInvolved: formFilter.isDirectorsInvolved,
          // isOurShareholdersInvolved: formFilter.isOurShareholdersInvolved,
          // isAuditorReportsProvided: formFilter.isAuditorReportsProvided,
          // isFinPositionStatementProvided:
          //   formFilter.isFinPositionStatementProvided,
          // isIncomeStatementProvided: formFilter.isIncomeStatementProvided,
          // isEquityChangesStatementProvided:
          //   formFilter.isEquityChangesStatementProvided,
          // isCashFlowStatementProvided: formFilter.isCashFlowStatementProvided,
          // isFinancialNotesStatementProvided:
          //   formFilter.isFinancialNotesStatementProvided,
        }}
        filterOptions={{
          fundUtilizationMainPurposes: {
            type: "select",
            label: "Main purpose of fund utilization",
            options: Array.isArray(mainPurposeOfFundUtilizationList.data)
              ? mainPurposeOfFundUtilizationList.data.map((item) => ({
                  id: item.id,
                  name: item.valueEn,
                }))
              : [],
          },
          termsOfAgreementChanges: {
            type: "select",
            label:
              "Will there be any changes to the Terms of Agreement attached to the securities being offered?",
            options: Array.isArray(termsOfAgreementChangesList.data)
              ? termsOfAgreementChangesList.data.map((item) => ({
                  id: item.id,
                  name: item.valueEn,
                }))
              : [],
          },
          investorsNumberRestriction: {
            type: "select",
            label:
              "Is there any restriction on the number of investors that can subscribe to this offer?",
            options: Array.isArray(investorsNumberRestrictionList.data)
              ? investorsNumberRestrictionList.data.map((item) => ({
                  id: item.id,
                  name: item.valueEn,
                }))
              : [],
          },
          islamicShariaCompliance: {
            type: "select",
            label:
              "Does the company/ project comply with Islamic Sharia provisions?",
            options: Array.isArray(islamicShariaComplianceList.data)
              ? islamicShariaComplianceList.data.map((item) => ({
                  id: item.id,
                  name: item.valueEn,
                }))
              : [],
          },
          fromDateApplication: {
            type: "date",
            label: "From Date Application",
          },
          toDateApplication: {
            type: "date",
            label: "To Date Application",
          },
          // isOurEmployeesInvolved: {
          //   type: 'checkbox',
          //   label: 'Our Employees Involved?',
          // },
          // isDirectorsInvolved: {
          //   type: 'checkbox',
          //   label: 'Is Directors Involved?',
          // },
          // isOurShareholdersInvolved: {
          //   type: 'checkbox',
          //   label: 'Our Shareholders Involved?',
          // },
          isOfferIssuerProvideDocuments: {
            type: "checkbox",
            label: "Did the offer issuer provide the following documents", 
          },
          // isAuditorReportsProvided: {
          //   type: "checkbox",
          //   label: "Auditor Reports",
          //   helperMessage:
          //     "Did the offer issuer provide the following documents",
          // },
          // isFinPositionStatementProvided: {
          //   type: "checkbox",
          //   label: "Statement of fin position",
          // },
          // isIncomeStatementProvided: {
          //   type: "checkbox",
          //   label: "Income Statement",
          // },
          // isEquityChangesStatementProvided: {
          //   type: "checkbox",
          //   label: "Statement of changes in equity",
          // },
          // isCashFlowStatementProvided: {
          //   type: "checkbox",
          //   label: "Cash flow statement",
          // },
          // isFinancialNotesStatementProvided: {
          //   type: "checkbox",
          //   label: "Notes on financial statement",
          // },
        }}
        onFilterChange={(filterName, value) =>
          handleFilterChange(filterName, value)
        }
      />
      <CustomDataTable
        key={key}
        columns={columns}
        count={
          opportunitiesListState.data &&
          typeof opportunitiesListState.data === "object" &&
          "item1" in opportunitiesListState.data
            ? opportunitiesListState.data.item1
            : 0
        }
        data={
          opportunitiesListState.data &&
          typeof opportunitiesListState.data === "object" &&
          "item2" in opportunitiesListState.data
            ? opportunitiesListState.data.item2
            : []
        }
        isColored={true}
        sortBy={sortBy}
        sortType={sortType}
        onSortChange={handleSortChange}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
      <CustomDialog
        text="Are you sure you want to delete this opportunity?"
        open={deleteConfirmationOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title="Confirm Deletion"
        buttonTitle="Delete"
        icon={<DeleteIcon />}
      />
    </div>
  );
};

export default OpportunitiesListForm;
